import React, { useState, useEffect } from 'react';
import { calculateShockFluid } from '../utils/calculators';

export default function ShockHelper() {
    const [weight, setWeight] = useState("");
    const [dehydration, setDehydration] = useState("");
    const [condition, setCondition] = useState(""); // hepatit, kidney, headtrauma
    const [result, setResult] = useState(null);

    // Java: showPopup() - Sayfa açıldığında profesyonel onay
    useEffect(() => {
        const isConfirmed = window.confirm("Profesyonel Kullanım Onayı\n\nBu hesaplayıcı yalnızca klinik karar verme sürecine yardımcı olmak amacıyla veteriner tıp çalışanları için geliştirilmiştir.\n\nKullanım sorumluluğunu kabul ediyor musunuz?");
        if (!isConfirmed) {
            window.location.href = "/"; // Kabul etmezse ana sayfaya atar
        }
    }, []);

    const handleCalculate = () => {
        if (!weight || !dehydration) {
            alert("Lütfen tüm değerleri giriniz.");
            return;
        }
        if (!condition) {
            alert("Lütfen klinik durum (Böbrek/Karaciğer/Kafa Travması) seçiniz.");
            return;
        }

        const res = calculateShockFluid({ weight: Number(weight), dehydration: Number(dehydration), condition });
        setResult(res);
    };

    return (
        <div style={containerStyle}>
            <h2 style={{ textAlign: 'center', color: '#e74c3c' }}>⚡ Şok Tedavi Yardımcısı</h2>
            
            <div style={formCard}>
                <div style={inputGroup}>
                    <label>Canlı Ağırlık (kg):</label>
                    <input type="number" value={weight} onChange={(e) => setWeight(e.target.value)} style={inputStyle} placeholder="0.0" />
                </div>
                
                <div style={inputGroup}>
                    <label>Dehidrasyon (%):</label>
                    <input type="number" value={dehydration} onChange={(e) => setDehydration(e.target.value)} style={inputStyle} placeholder="0" />
                </div>

                <div style={checkboxSection}>
                    <p><strong>Klinik Durum (Birini Seçiniz):</strong></p>
                    <label style={labelStyle}>
                        <input type="radio" name="cond" checked={condition === 'kidney'} onChange={() => setCondition('kidney')} /> Böbrek Yetmezliği
                    </label>
                    <label style={labelStyle}>
                        <input type="radio" name="cond" checked={condition === 'hepatit'} onChange={() => setCondition('hepatit')} /> Karaciğer Yetmezliği
                    </label>
                    <label style={labelStyle}>
                        <input type="radio" name="cond" checked={condition === 'headtrauma'} onChange={() => setCondition('headtrauma')} /> Kafa Travması
                    </label>
                </div>

                <button onClick={handleCalculate} style={btnStyle}>HESAPLA</button>
            </div>

            {result && (
                <div style={resultBox}>
                    <h3 style={{ color: '#c0392b', marginTop: 0 }}>Toplam İhtiyaç: {result.totalNeed} ml</h3>
                    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', lineHeight: '1.5', wordBreak: 'break-word' }}>{result.resultMessage}</pre>
                </div>
            )}
        </div>
    );
}

// --- TASARIM NESNELERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const containerStyle = { 
    padding: '15px', 
    maxWidth: '500px', 
    margin: '0 auto', 
    fontFamily: 'sans-serif', 
    backgroundColor: '#1a1a1a', 
    color: '#fff', 
    minHeight: '100vh',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))', // iOS Çentik Koruması
    paddingBottom: 'env(safe-area-inset-bottom)'       // iOS Alt Bar Koruması
};

const formCard = { 
    background: '#262626', 
    padding: '20px', 
    borderRadius: '10px', 
    border: '1px solid #333',
    boxSizing: 'border-box',
    width: '100%'
};

const inputGroup = { marginBottom: '15px', boxSizing: 'border-box' };

const inputStyle = { 
    width: '100%', 
    padding: '10px', 
    background: '#333', 
    border: '1px solid #444', 
    color: '#fff', 
    borderRadius: '5px',
    fontSize: '16px', // iOS Safari zoom engellemek için kritik
    boxSizing: 'border-box',
    outline: 'none',
    WebkitAppearance: 'none'
};

const checkboxSection = { margin: '20px 0', borderTop: '1px solid #333', paddingTop: '10px', boxSizing: 'border-box' };
const labelStyle = { display: 'block', marginBottom: '10px', cursor: 'pointer' };

const btnStyle = { 
    width: '100%', 
    padding: '15px', 
    background: '#e74c3c', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '5px', 
    fontWeight: 'bold', 
    cursor: 'pointer',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent'
};

const resultBox = { 
    marginTop: '20px', 
    padding: '20px', 
    background: '#2c3e50', 
    borderRadius: '10px', 
    borderLeft: '5px solid #e74c3c',
    boxSizing: 'border-box',
    width: '100%'
};